import { getWithJWT } from "./httpService";

export function get(credentials, url) {
  return getWithJWT(credentials, url);
}
